
export const bestCourses = [
    {
        "description":"Aprende con Ana los conceptos fundamentales de las estrategias Inbound Marketing, las herramientas para su aplicación y logra conectar con los consumidores de tu emprendimiento para convertirlos en nuevos clientes y promotores de la marca.",
        "id": "9",
        "image": "https://lwfiles.mycourse.app/eanx-public/3ef29c8dd2bdedd6febeb7a9607ba4f6.jpeg",
        "instructor": "Ana María Gómez Sanabria",
        "level": "Curso",
        "name": "Inbound Marketing",
        "courseId": "inbound-marketing",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 80,
    },
    {
        "description":"Junto a Leonardo, aprende los conocimientos básicos sobre impuestos, más allá de liquidarlos, que un emprendedor (Persona natural o jurídica) requiere saber para desarrollar una actividad económica.",
        "id": "8",
        "image": "https://lwfiles.mycourse.app/eanx-public/2594e83f1d657b921a0e5471118f8480.jpeg",
        "instructor": "Leonardo Grajales Villa",
        "level": "Curso",
        "name": "Fundamentos de Impuestos para Emprendedores",
        "courseId": "fundamentos-de-impuestos-para-emprendedores",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 175,
    },
    {
        "description":"En este curso, Jeisson te enseñará los conceptos básicos de los mercados de capitales, y conocerás como usar una herramienta aplicable a los mercados de capitales para inversión y fortalecer tus finanzas personales.",
        "id": "7",
        "image": "https://lwfiles.mycourse.app/eanx-public/31a8f9db24136b906334e4729f33bf3d.jpeg",
        "instructor": "Jeisson Andrés Balaguera Alape",
        "level": "Curso",
        "name": "Trading",
        "courseId": "trading",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 139,
    },
    {
        "description":"Aprende a entender, gestionar y ejecutar una estrategia de automatización para tu proyecto, optimizando tus procesos y costos. Entenderás la importancia de los procesos a la hora de construir una base de datos integrada.",
        "id": "13",
        "image": "https://lwfiles.mycourse.app/eanx-public/27d20ad89b0a07f99f8909a0db864dc0.jpeg",
        "instructor": "Daniel Aguillón",
        "level": "Curso",
        "name": "Estrategia de Marketing Automation",
        "courseId": "estrategia-marketing-automation",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 121,
    },
    {
        "description":"En este curso conocerás diversas herramientas básicas que podrás utilizar en todas las etapas de los procesos de  innovación, para llevar tus ideas más allá de las barreras.",
        "id": "11",
        "image": "https://lwfiles.mycourse.app/eanx-public/4128f58d3bbd37e0cee37bc4ff6f4864.jpeg",
        "instructor": "Paula Echeverry Pérez",
        "level": "Curso",
        "name": "Herramientas básicas de Innovación",
        "courseId": "herramientas-basicas-de-innovacion",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 69,
    },
    {
        "description":"La mayoría de las personas piensa que para invertir en criptomonedas es necesario ser un genio en finanzas o experto en informática. Lo cierto es que apenas en unos clics, podrás empezar tu camino como inversionista en criptomonedas. En este curso, conocerás las diferentes opciones de inversión que existen, sus riesgos, beneficios y cómo acceder a ellas de forma sencilla y segura.",
        "id": "10",
        "image": "https://lwfiles.mycourse.app/eanx-public/127aa70e14d87d56b887746bb0deb221.jpeg",
        "instructor": "Angelo Rossi",
        "level": "Curso",
        "name": "Invertir en Criptomonedas",
        "courseId": "invertir-en-criptomonedas",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 110,
    },
    {
        "description":"Mateo, growth hacker y consultor en estrategias de marketing digital, te enseña las nuevas funcionalidades de Google Analytics 4, que ha evolucionado para ofrecerte mejores maneras de segmentar, nuevos tipos de reportes y en general, mejores formas de entender la data para alcanzar tus objetivos de conversión.",
        "id": "4",
        "image": "https://lwfiles.mycourse.app/eanx-public/c2770836721302c2e003d76a832e7af4.jpeg",
        "instructor": "Mateo Peralta",
        "level": "Curso",
        "name": "Google Analytics 4",
        "courseId": "google-analytics-4",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 316,
    },
    {
        "description":"En este curso de OKR, nuestra experta te acompaña a soñar en grande, con objetivos realizables en corto y mediano plazo, para alcanzar la visión de tu compañía.",
        "id": "2",
        "image": "https://lwfiles.mycourse.app/eanx-public/f220f164078524a1ae8358fc9a37252c.jpeg",
        "instructor": "Johanna Arévalo",
        "level": "Curso",
        "name": "OKR",
        "courseId": "okr",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 53,
    },
    {
        "description":"En esta cápsula, conocerás cómo es el ADN de un emprendedor sostenible, aprenderás cómo es el modelo de negocio de los emprendimientos sostenibles y podrás descubrir si tus actitudes y conocimientos, están alineados con la posibilidad de ser un emprendedor sostenible.",
        "id": "36",
        "image": "https://lwfiles.mycourse.app/eanx-public/b1cb8d888723cc5d82c724f31aef6a92.jpeg",
        "instructor": "Paola Franco y Mauricio Reyes",
        "level": "Cápsula",
        "name": "Cápsula La Oportunidad de Ser un Emprendedor Sostenible",
        "courseId": "capsulaemprendedor-sostenible",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 31,
    },
    {
        "description":"¡Aprende a vincular y configurar una página web con Google Tag Manager desde la perspectiva del Marketing! En este curso conocerás las funcionalidades de la herramienta y las soluciones que puede brindarle a tu estrategia digital, entendiendo paso a poso cómo realizar la vinculación de tu web para alcanzar tus objetivos.",
        "id": "37",
        "image": "https://lwfiles.mycourse.app/eanx-public/a1cc61155897318acebf9f45ebb6c578.jpeg",
        "instructor": "María Paula Palomino Marroquín",
        "level": "Cápsula",
        "name": "Cápsula Google Tag Manager",
        "courseId": "googletagmanager",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 33,
    },
    {
        "description":"En esta cápsula aprenderás cuáles son las herramientas son útiles para realizar Social Listening (Escucha Social) y la metodología que puedes llevar a cabo para conseguir insights de valor y así conocer a las audiencias relevantes para la organización y el mercado.",
        "id": "12",
        "image": "https://lwfiles.mycourse.app/eanx-public/fd046db914d38ffa2446b1c3cb87752f.jpeg",
        "instructor": "Dhiana Espitia Jaramillo",
        "level": "Cápsula",
        "name": "Cápsula Social Listening",
        "courseId": "social-listening",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 24,
    },
    {
        "description":"En esta cápsula de TikTok Ads, conocerás cómo es la plataforma interna de anuncios de TikTok y cómo estructurar una campaña dentro de esta red social. Además, aprenderás la formula en la que el contenido aporta a tu estrategia de anuncios.",
        "id": "3",
        "image": "https://lwfiles.mycourse.app/eanx-public/a83894a4e57dc63b16cad8fb752523fd.jpeg",
        "instructor": "Daniel Aguillón",
        "level": "Cápsula",
        "name": "Cápsula TikTok Ads",
        "courseId": "tiktok-ads",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 29,
    },
    /*{
        "description":"En este curso de Growth Marketing, aprenderás las técnicas y herramientas para desarrollar campañas de marketing digital implementando experimentos de Growth y optimizando las campañas a partir de la data obtenida de tus resultados, con el fin aumentar la cantidad de conversiones y los ingresos en las empresas.",
        "id": "10819",
        "image": "https://lwfiles.mycourse.app/eanx-public/ad03e96d207ab1d8a085fc94d305c6f5.jpeg",
        "instructor": "Mateo Peralta",
        "level": "Curso",
        "name": "Growth Marketing",
        "courseId": "growth-marketing",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 540,
    },

 
    {
        "description":"En este curso del Instituto de Emprendimiento Sostenible, podrás acceder a las herramientas que te permitan validar tu idea de negocio y llegar a la elaboración de tu Producto Mínimo Viable. El IES, pone a tu disposición el saber de tus expertos y podrás acceder a mentorías directamente con ellos.",
        "id": "10812",
        "image": "https://lwfiles.mycourse.app/eanx-public/0b6fc1a829aacbe95f4c522a95284b27.jpeg",
        "instructor": "Equipo de expertos",
        "level": "Curso",
        "name": "Validación de Ideas de Negocios Sostenibles",
        "courseId": "validacion-ideas-negocios-sostenibles",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 169,
    },
    {
        "description":"En este curso el estudiante aprenderá a diseñar y liderar una estrategia de redes sociales para marcas, empresas y/o personas.\\n\\nConocerá en profundidad las propiedades de las redes sociales más reconocidas y podrá aprovechar sus características en el diagnóstico, construcción e implementación de su estrategia; además, adquirirá tácticas y tips prácticos que contribuyen a implementar con éxito un plan en redes sociales.",
        "id": "10818",
        "image": "https://lwfiles.mycourse.app/eanx-public/db8beb38b5afe1c6f2cd45d74fc348c3.jpeg",
        "instructor": "Alejandra Melo Benítez",
        "level": "Curso",
        "name": "Estrategia de Redes Sociales",
        "courseId": "estrategia-redes-sociales",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 324,
    },
    {
        "description":"En este curso, el estudiante podrá acceder a las herramientas necesarias para convertirse en un orador con un estilo propio. Aprenderá a construir mensajes dotando de un sentido propio el discurso que va a presentar, y aprovechará las posibilidades del lenguaje corporal, de los recursos de apoyo y del tiempo, para una comunicación clara y efectiva. Además, podrá diferenciar los requerimientos discursivos de distintos tipos de escenarios y audiencias, para transmitir ideas que impacten a su público.",
        "id": "10820",
        "image": "https://lwfiles.mycourse.app/eanx-public/825064742ddb31b4f44361bbd9ae829a.jpeg",
        "instructor": "Santiago Rivas",
        "level": "Curso",
        "name": "Oratoria y Presentaciones Efectivas",
        "courseId": "oratoria-presentaciones-efectivas",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 3,
        "time_minutes": 546,
    },
    {
        "description":"Desarrollar una mentalidad creativa a través del diseño, que te permita una nueva manera de pensar y actuar, ideando soluciones tangibles y ágiles a tus retos, con el apoyo de herramientas propias del design thinking y otras metodologías de diseño.",
        "id": "10824",
        "image": "https://lwfiles.mycourse.app/eanx-public/6711933086aad7c00198ef659a7bbe95.jpeg",
        "instructor": "Jole Restrepo",
        "level": "Curso",
        "name": "Design Mindset: Mentalidad de Diseño",
        "courseId": "design-mindset-mentalidad-de-diseno",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 3,
        "time_minutes": 94,
    },
    {
        "description":"En este curso, adquirirás las herramientas para gestionar la información institucional a través de los voceros que conocen los medios de comunicación y saben actuar acorde, y en el proceso identificar y manejar una crisis.",
        "id": "10817",
        "image": "https://lwfiles.mycourse.app/eanx-public/8b4e4b9d727f018da474f7bbf7fe8746.jpeg",
        "instructor": "Nicolás Umaña Jimeno",
        "level": "Curso",
        "name": "Medios, Vocería y Manejo de Crisis",
        "courseId": "medios-voceria-manejo-crisis",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 2,
        "time_minutes": 49,
    },
    {
        "description":"Power BI se está convirtiendo poco a poco como la plataforma de inteligencia de negocios más poderosa y herramienta absolutamente esencial para los profesionales del área de datos de las empresas. Y es que esta herramienta se puede conectar a muchas fuentes de datos, permite construir modelos de información bastante complejos y, sobre todo, permite crear tableros de control interactivos bastante llamativos. \\n\\nEn este curso buscamos presentar a los participantes los elementos constitutivos de la herramienta de visualización Power BI, proporcionándoles los conocimientos básicos para que los analistas de datos puedan conectar datos, modelarlos, visualizarlos y analizarlos a través de la construcción de tableros de control y KPI’s, que permitirán a las personas indicadas de las empresas, tener las bases necesarias para tomar decisiones objetivas.",
        "id": "10821",
        "image": "https://lwfiles.mycourse.app/eanx-public/314f8ef9a7fa4972b74a6facf0713350.jpeg",
        "instructor": "Luis Armando Cobo",
        "level": "Curso",
        "name": "Análisis de Datos en Power BI",
        "courseId": "power-bi",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 2,
        "time_minutes": 141,
    },
    {
        "description":"En este curso, aprenderás a  programar desde cero con Python. Aprenderás las bases para resolver un problema a través de una solución algorítmica con ayuda del lenguaje de programación Python, conocerás cómo trabajar con Git, los conceptos básicos, clonar un repositorio y gestionar tus proyectos alojándolos en tu repositorio local y en GitHub.",
        "id": "10815",
        "image": "https://lwfiles.mycourse.app/eanx-public/e569b36e966d300ef33794d3dd60558c.jpeg",
        "instructor": "Brayan Torres",
        "level": "Curso",
        "name": "Aprender a Programar con Python",
        "courseId": "aprender-programar-python",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 5,
        "time_minutes": 147,
    },
    {
        "description":"Si eres un emprendedor, ya sea por naturaleza o por necesidad, este es el curso para ti. Nuestra profesora, te acompañará en el proceso de darle forma y sustento a tu idea para que los inversionistas no se pierdan la oportunidad de apoyar un proyecto como el tuyo.",
        "id": "10823",
        "image": "https://lwfiles.mycourse.app/eanx-public/a17efe23e47aee25ce600c74519e2b79.jpeg",
        "instructor": "Gigliola Aycardi Batista",
        "level": "Curso",
        "name": "De la Idea al Éxito: Curso para Emprendedores",
        "courseId": "de-la-idea-al-exito-curso-para-emprendedores",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 219,
    },
    {
        "description":"En este curso, los estudiantes podrán reconocer los debates contemporáneos acerca de la sostenibilidad y la complejidad conceptual y práctica de su aplicación en los territorios. Además, obtendrá herramientas para hacer la transición de las empresas hacia el emprendimiento sostenible.",
        "id": "10822",
        "image": "https://lwfiles.mycourse.app/eanx-public/c368ceca98f917cbafaf69ec82eda551.jpeg",
        "instructor": "Brigitte Baptiste",
        "level": "Curso",
        "name": "Acciones Sostenibles para Transformar el Mundo",
        "courseId": "acciones-sostenibles",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 314,
    },
    {
        "description":"En este curso, podrás identificar las identidades de género no binarias, y reconocer las experiencias de vida Trans. Te enseña herramientas prácticas para el tránsito y el acompañamiento al mismo e identificarás herramientas para la defensa de tus derechos.",
        "id": "14405",
        "image": "https://lwfiles.mycourse.app/eanx-public/82dc2b98504212d01e3fda931dcfbe33.jpeg",
        "instructor": "Fundación GAAT",
        "level": "Curso",
        "name": "Experiencias de Vida Trans",
        "courseId": "experiencias-vidas-trans",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 144,
    },
    {
        "description":"En esta cápsula, aprenderás los principales elementos para la disciplina u oficio de la Gestión Cultural. Si eres creador o acompañas procesos creativos, podrás entender cómo se diseña, ejecuta y se mide un proyecto asociado a las expresiones artísticas o las prácticas culturales.",
        "id": "12005",
        "image": "https://lwfiles.mycourse.app/eanx-public/94e086de38f4c19c43bee43f776d45ee.jpeg",
        "instructor": "Catalina Ceballos",
        "level": "Cápsula",
        "name": "Cápsula Diseño, ejecución y medición de un proyecto cultural",
        "courseId": "diseno-ejecucion-y-medicion-de-un-proyecto-cultural",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 43,
    },
    {
        "description":"Esta cápsula, te permite dominar los fundamentos conceptuales que rigen el Mercadeo Sostenible, desde su definición hasta su aplicación estratégica en la creación o transición hacía lo verde y serás capaz de analizar las diferentes variables de segmentación de mercados verdes que diferencian la conducta del consumidor proambiental.",
        "id": "11999",
        "image": "https://lwfiles.mycourse.app/eanx-public/ccaef9ab456b6154c67bd39b328b3ef1.jpeg",
        "instructor": "Haidy Moreno",
        "level": "Cápsula",
        "name": "Cápsula Marketing Mix para los Consumidores Ambientales",
        "courseId": "marketing-consumidores-ambientales",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 44,
    },
    {
        "description":"En esta cápsula aprenderás cómo calcular la tasa de conversión de un sitio web y su utilidad para determinar futuras inversiones en generación de tráfico hacia el sitio web.",
        "id": "12006",
        "image": "https://lwfiles.mycourse.app/eanx-public/0b4d92d2b041f41bcd3b6df5a169c97d.jpeg",
        "instructor": "Juan Carlos Rentería García",
        "level": "Cápsula",
        "name": "Cápsula Calcular la tasa de conversión de un sitio web",
        "courseId": "calcular-la-tasa-de-conversion-de-un-sitio-web",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 16,
    },
    {
        "description":"Esta cápsula presenta el modelo de decisión de compra de un consumidor aplicando al mismo tiempo la herramienta de perfil persona para entender cómo toma decisiones dicho consumidor. Resulta que el uso del modelo combinado con el perfil persona nos puede dar un buen resultado para como toma decisiones dicho consumidor.",
        "id": "12004",
        "image": "https://lwfiles.mycourse.app/eanx-public/0cd44b3ffa6728ad290485c7e4a185b7.jpeg",
        "instructor": "Mauricio Sabogal",
        "level": "Cápsula",
        "name": "Cápsula Modelo de decisión de compra",
        "courseId": "modelo-de-decision-de-compra",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 63,
    },
    {
        "description":"Con esta cápsula, aprende cuáles son las tecnologías que están revolucionando los sistemas tecnológicos y urbanos.",
        "id": "12001",
        "image": "https://lwfiles.mycourse.app/eanx-public/96af9fc5b6313f810cef8b93b8cff4e7.jpeg",
        "instructor": "Leonardo Rodríguez Urrego",
        "level": "Cápsula",
        "name": "Cápsula Tecnología para ciudades inteligentes y sostenibles",
        "courseId": "smartcities",
        "newCourse": false,
        "number_opinions": 0,
        "number_students": 0,
        "stars": 4,
        "time_minutes": 75,
    },*/
]